export default __webpack_public_path__ + "static/media/ag.c32c61cd.jpg";